import { useQuery } from "@tanstack/react-query";
import axios from "axios";

export type AnnouncementType = "INFO" | "WARNING" | "ERROR";

export interface Announcement {
  id: string;
  title: string;
  message: string;
  type: AnnouncementType;
  linkUrl: string | null;
  linkText: string | null;
}

interface AnnouncementsResponse {
  data: Announcement[];
}

export const useActiveAnnouncements = () => {
  return useQuery({
    queryKey: ["announcements", "active"],
    queryFn: async () => {
      const response = await axios.get<AnnouncementsResponse>(
        `${import.meta.env.VITE_API_URL}/api/v2/announcements/active`
      );
      return response.data.data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
};
